














































































import { Component, Inject, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import Product, { Boat } from '@/api/product';
import InlineEdit from '@/components/InlineEdit.vue';
import { getAuthInstance } from '@/store/auth';
import { AdminFeatureFlags } from '@/api/utils';
import { Show } from '@/api/shows';

@Component({
  components: {
    InlineEdit,
  },
})
export default class Home extends Vue {
  @Action('auth/getUser') public getUser!: () => Promise<any>;
  @Action('auth/getIdTokenClaims') public getIdTokenClaims!: (o?: any) => Promise<object>;
  @Action('product/loadProducts') public loadProducts!: () => Promise<void>;
  @Action('product/deleteProduct') public deleteProduct!: (p: Product) => Promise<void>;
  @Getter('product/products') public prods!: Product[];
  @Getter('product/boats') public boats!: Boat[];
  @Action('product/saveBoat') public saveBoat!: (b: Boat) => Promise<void>;
  @Action('product/createBoat') public createBoat!: (b: Boat) => Promise<void>;
  @Action('product/deleteBoat') public deleteBoat!: (b: Boat) => Promise<void>;
  @Action('shows/loadShows') public loadShows!: () => Promise<void>;
  @Getter('shows/shows') public shows!: Show[];
  @Inject() public readonly flags!: AdminFeatureFlags;

  public get items() {
    if (this.flags.useShows) {
      return this.shows;
    }
    return this.prods;
  }

  public get title(): string {
    return this.flags.useShows ? 'Shows' : 'Products';
  }

  public headers = [
    {
      text: 'Name',
      align: 'left',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Description',
      align: 'left',
      value: 'desc',
      sortable: false,
    },
    {
      text: 'Boat',
      align: 'left',
      value: 'boatId',
    },
    {
      text: 'Publish',
      align: 'center',
      value: 'publish',
      sortable: true,
    },
    {
      text: 'Actions',
      align: 'left',
      value: 'action',
      filterable: false,
      sortable: false,
    },
  ];

  public boatHeaders = [
    {
      text: 'Boat Name',
      align: 'left',
      value: 'name',
      filterable: false,
      sortable: false,
    },
    {
      text: 'Color',
      align: 'left',
      value: 'color',
      filterable: false,
      sortable: false,
    },
    {
      text: '',
      align: 'left',
      value: 'colorprev',
      filterable: false,
      sortable: false,
    },
    {
      text: 'Actions',
      align: 'center',
      value: 'actions',
      filterable: false,
      sortable: false,
    },
  ];


  public loading = false;
  public search = '';
  public confirm = false;
  public delProd: Product | null = null;
  public user: {[claim: string]: string | string[]} = {};

  public async mounted() {
    this.user = await this.getUser();    
  }

  public get isAdmin(): boolean {
    return this.user[process.env.VUE_APP_AUTH0_CLAIM_NAMESPACE + 'role']?.includes('admin');
  }

  public async addBoat() {
    await this.createBoat({id: 0, name: 'Next Boat', color: '000000'});
  }

  public getBoat(id: number): Boat | undefined {
    return this.boats.find((b) => b.id === id);
  }

  public async del() {
    if (this.delProd === null) { return; }

    await this.deleteProduct(this.delProd);
    await this.loadProducts();
    this.confirm = false;
    this.delProd = null;
  }

  public async created() {
    if (this.flags.useShows && !this.shows.length) {
      this.loading = true;
      await this.loadShows();
      this.loading = false;
    } else if (!this.prods.length) {
      this.loading = true;
      await this.loadProducts();
      this.loading = false;
    }
  }
}
